(function () {
  'use strict';

  var DISCOUNT_KEY = 'zg_discount';
  var CART_UPDATE_URL = '/cart/update.js';

  function readDiscountFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('discount');
  }

  function storeDiscount(code) {
    if (!code) return;

    try {
      sessionStorage.setItem(DISCOUNT_KEY, String(code).trim());
    } catch (error) {
      /* ignore */
    }
  }

  function applyDiscountToCart(code) {
    var normalized = String(code || '').trim();
    if (!normalized) {
      return Promise.resolve(null);
    }

    return fetch(CART_UPDATE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: normalized
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to apply discount.');
        }
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function init() {
    var code = readDiscountFromUrl();
    if (!code) return;

    storeDiscount(code);

    applyDiscountToCart(code).then(function (cart) {
      document.dispatchEvent(
        new CustomEvent('ghost:discount-applied', {
          detail: {
            code: code,
            cart: cart
          }
        })
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
